<template>
    <div class="form-group col-12">
        <div
            class="group_bar"
            :class="{ 'is-invalid': hasError }"
            @click="toggleGroup"
        >
            <h4>{{ content.name }}</h4>

            <span>
                <i class="fas fa-angle-right" :class="{ rotated: isOpen }" />
            </span>
        </div>

        <div v-if="isOpen" :key="updateKey" class="col-12">
            <div class="groups_container">
                <draggable
                    :list="content.users"
                    handle=".handle"
                    @start="drag = true"
                    @end="onMoved"
                >
                    <single-person
                        v-for="(user, index) of content.users"
                        :key="index"
                        v-model="content.users[index]"
                        :index="index"
                        :v="v"
                        :server-errors="serverErrors"
                        @remove="removeUser(index)"
                    />
                </draggable>
            </div>

            <button
                class="col-md-1 col-sm-2 col-3 btn btn-success waves-effect waves-ligh mr-3"
                style="margin-top: 1rem;"
                type="button"
                @click="addUser"
            >
                <i class="fas fa-plus-circle" /> Add
            </button>
        </div>
    </div>
</template>

<script>
import Draggable from 'vuedraggable';
import SinglePerson from '@/components/about/SinglePerson';

export default {
    components: {
        Draggable,
        SinglePerson
    },

    props: {
        group: {
            type: Object,
            required: true
        },
        v: {
            type: Object,
            required: true,
            default: () => ({})
        },
        serverErrors: {
            type: Array,
            required: true
        }
    },

    data() {
        return {
            content: {},
            updateKey: 0,
            isOpen: false
        };
    },

    computed: {
        hasError() {
            return this.v.$error || this.serverErrors.length;
        }
    },

    watch: {
        content() {
            this.$emit('input', this.content);
        }
    },

    mounted() {
        this.content = { ...this.group };

        if (this.content.order === 1) {
            this.isOpen = true;
        }
    },

    methods: {
        addUser() {
            this.content.users.push({});
        },

        removeUser(index) {
            this.content.users.splice(index, 1);
            this.updateKey++;
        },

        toggleGroup() {
            this.isOpen = !this.isOpen;
        },

        onMoved() {
            this.drag = false;
            this.updateKey++;
        }
    }
};
</script>
